import React from 'react';

const ErrorFallback = ({ error }) => {
  return (
    <div className='text-red'>
      Some thing wrong! <br />
      {error.message}
    </div>
  );
};

export default ErrorFallback;
